import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import { PageHero, CtaBand, Overline } from "../components/Primitives";
import { IMG } from "../lib/assets";
import { Seo } from "../components/Seo";

export default function Philosophy() {
  const { t } = useLang();
  const sections = t("philosophy.sections");
  return (
    <div data-testid="philosophy-page">
      <Seo pageKey="philosophy" path="/philosophy" />
      <PageHero overline={t("philosophy.heroOverline")} title={t("philosophy.title")} intro={t("philosophy.intro")} image={IMG.philosophy} />

      <section className="relative py-8 md:py-16">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10">
          {sections.map((s, i) => (
            <Reveal key={i} delay={0.05} className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 border-t border-white/10 py-14 md:py-20">
              <div className="md:col-span-5 flex items-start gap-6">
                <span className="font-serif text-3xl text-kenosis-gold/40">{String(i + 1).padStart(2, "0")}</span>
                <h2 className="font-serif text-3xl md:text-4xl font-light leading-tight tracking-tight text-kenosis-ivory">{s.title}</h2>
              </div>
              <p className="md:col-span-7 self-center font-sans text-base md:text-lg font-light leading-relaxed text-kenosis-muted">{s.text}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBand />
    </div>
  );
}
